// User role constants
export const USER_ROLES = {
  ENTREPRENEUR: 'entrepreneur',
  ADMIN: 'admin'
};

// Valid roles array for validation
export const VALID_ROLES = Object.values(USER_ROLES);

// Default role for new users
export const DEFAULT_ROLE = USER_ROLES.ENTREPRENEUR;

// Role validation helper
export const isValidRole = (role) => {
  return VALID_ROLES.includes(role);
};

// Role permissions
export const ROLE_PERMISSIONS = {
  [USER_ROLES.ENTREPRENEUR]: [
    'create_listings',
    'view_listings',
    'send_messages',
    'update_own_profile'
  ],
  [USER_ROLES.ADMIN]: [
    'create_listings',
    'view_listings', 
    'send_messages',
    'update_own_profile',
    'moderate_content',
    'view_admin_panel',
    'manage_users',
    'view_reports'
  ]
};

// Check if user has permission
export const hasPermission = (userRole, permission) => {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
};